import React from "react";
import ModalButtons from "./modal-buttons";
import ModalHeaderButtons from "./modal-header-buttons";
var Isvg = require("../../../vendor/react-inlinesvg");

class VstModalContainer extends React.Component {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.modalheaderRef = React.createRef();

    this._updateWindowValues = this._updateWindowValues.bind(this);
    this._updateModalLocation = this._updateModalLocation.bind(this);
    this._escapeKey = this._escapeKey.bind(this);
    this._removeModal = this._removeModal.bind(this);
    this.saveCallback = this.saveCallback.bind(this);
    this.cancelCallback = this.cancelCallback.bind(this);
    this._redraw = this._redraw.bind(this);
    this._updateHeaderHeight = this._updateHeaderHeight.bind(this);
    this._changeTitle = this._changeTitle.bind(this);
    this._toggleCloseButton = this._toggleCloseButton.bind(this);
    this._toggleDropDown = this._toggleDropDown.bind(this);
    this._toggleCancelButton = this._toggleCancelButton.bind(this);
    this._toggleSaveButton = this._toggleSaveButton.bind(this);
    this._changeDescription = this._changeDescription.bind(this);
    this._changeSize = this._changeSize.bind(this);

    this.state = {
      intersitial: props.intersitial,
      title: props.title,
      description: props.description,
      width: props.width,
      height: props.height,
      focusedElementBeforeModal: document.activeElement,
      elementToFocusOnModal: null,
      modalHeaderHeight: 0,
      hideCloseButton: props.hideCloseButton,
      launchBanner: props.launchBanner,
      modalContainerHeader: props.modalContainerHeader,
      dropDownVisible: false,
      content: React.cloneElement(props.content, {
        changeModalTitle: this._changeTitle,
        changeModalDescription: this._changeDescription,
        changeModalSize: this._changeSize,
        toggleCloseButton: this._toggleCloseButton,
        toggleCancelButton: this._toggleCancelButton,
        toggleSaveButton: this._toggleSaveButton,
        toggleDropDown: this._toggleDropDown
      })
    };
  }

  componentDidMount() {
    this.mounted = true;

    $(window).on("keyup", this._escapeKey);
    Fraction.Helpers.forceModalUpdate = this._redraw;
    $(window).on("resize", this._updateModalLocation);
    if (this.props.elementToFocusOnModal) {
      $(this.props.elementToFocusOnModal).focus();
    } else if (!Fraction.TourQueue || Fraction.TourQueue.length === 0) {
      $("#modal-container")
        .find(":focusable")
        .first()
        .focus();
    }

    if (Fraction.Helpers.vstModalCloseRefocus.length > 0) {
      this.setState({ focusedElementBeforeModal: false });
    }

    Fraction.Helpers.runAfterRender(() => {
      this._updateHeaderHeight();
    });
  }

  componentWillUnmount() {
    $(window).unbind("keyup", this._escapeKey);
    $(window).unbind("resize", this._updateModalLocation);
    if (this.state.focusedElementBeforeModal) {
      Fraction.Helpers.runAfterRender(() => {
        this.state.focusedElementBeforeModal.focus();
      });
    }

    this.mounted = false;
  }

  _updateWindowValues() {
    if (this.mounted) {
      this._updateHeaderHeight();
    }
  }

  _updateModalLocation() {
    Fraction.Helpers.updateVSTModalLocation();
    if (
      Fraction.Helpers.isSmallScreen() &&
      this.modalRef.current.clientWidth >= $(window).width() &&
      this.props.intersitial
    ) {
      this.setState({ intersitial: true });
    } else {
      this.setState({ intersitial: false });
    }
  }

  _topTrapKey() {
    $("#modal-container")
      .find(":focusable")
      .last()
      .focus();
  }

  _bottomTrapKey() {
    $("#modal-container")
      .find(":focusable")
      .first()
      .focus();
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      this.props.modalCloseCallback();
      Fraction.Helpers.removeVSTModal(e, $(".modal"));
    }
  }

  _removeModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.props.modalCloseCallback();
    Fraction.Helpers.removeVSTModal(e);
  }

  saveCallback(e) {
    if (this.state.saveCallback) {
      this.state.saveCallback();
    }
  }

  cancelCallback(e) {
    if (this.state.cancelCallback) {
      this.state.cancelCallback();
    }
  }

  _preventClose(e) {
    e.stopPropagation();
  }

  // redraw this container!
  _redraw() {
    setTimeout(() => this.forceUpdate(), 0);
  }

  _touchMove(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _updateHeaderHeight(modalHeaderHeight) {
    modalHeaderHeight =
      this.modalheaderRef.current && this.modalheaderRef.current.offsetHeight;
    if (modalHeaderHeight >= 95) {
      this.setState({ modalHeaderHeight: modalHeaderHeight });
    } else {
      this.setState({ modalHeaderHeight: false });
    }
  }

  _changeTitle(title) {
    this.setState({ title: title }, () => {
      this._updateModalLocation();
    });
  }

  _toggleCloseButton(hideCloseButton) {
    this.setState({ hideCloseButton });
  }

  _toggleDropDown(dropDownVisible) {
    this.setState({ dropDownVisible });
  }

  _toggleCancelButton(showCancelButton, cancelCallback) {
    this.setState({ showCancelButton, cancelCallback });
  }

  _toggleSaveButton(showSaveButton, saveCallback) {
    this.setState({ showSaveButton, saveCallback });
  }

  _changeDescription(description) {
    this.setState({ description: description }, () => {
      this._updateHeaderHeight();
      this._updateModalLocation();
    });
  }

  _changeSize(width, height) {
    var newWidth, newHeight;
    if (this.state.width != width) {
      if (this.state.width < width) {
        newWidth = Math.min(this.state.width + 10, width);
      } else {
        newWidth = Math.max(this.state.width - 10, width);
      }
      this.setState({ width: newWidth }, () => {
        this._updateModalLocation();
        setTimeout(() => {
          this._changeSize(width, height);
        }, 10);
      });
    } else if (this.state.height != height) {
      if (this.state.height < height) {
        newHeight = Math.min(this.state.height + 10, height);
      } else {
        newHeight = Math.max(this.state.height - 10, height);
      }
      this.setState({ height: newHeight }, () => {
        this._updateModalLocation();
        setTimeout(() => {
          this._changeSize(width, height);
        }, 10);
      });
    }
  }

  render() {
    var buttons = this.props.buttons || [];
    var modalStyles = {};
    if (this.props.position) {
      modalStyles.left = this.props.position.left;
      modalStyles.top = this.props.position.top;
    }
    if (!Fraction.Helpers.isSmallScreen()) {
      if (this.state.width) {
        modalStyles.width = this.state.width;
      }
      if (this.state.height) {
        modalStyles.height = this.state.height;
      }
    } else {
      modalStyles.left = 0;
      modalStyles.top = 0;
      modalStyles.height = "100%";
      modalStyles.width = "100%";
    }

    return (
      <div>
        <div
          aria-hidden={true}
          onFocus={this._topTrapKey}
          className="traptabkey"
          tabIndex={0}
        />
        <div
          ref={this.modalRef}
          id="modal-container"
          className={
            "modal-vstui " +
            this.props.definingClass +
            " " +
            this.props.modalDimensions +
            " " +
            this.props.padding +
            " " +
            (this.state.dropDownVisible ? " dropDownVisible" : " ") +
            (this.props.position ? " ignore-position" : " ")
          }
          onClick={this._preventClose}
          aria-labelledby="modal-title"
          style={modalStyles}
        >
          <div
            className={
              "modal-box" + (this.state.intersitial ? " intersitial" : "")
            }
          >
            <div
              id="modal-header"
              className={
                this.state.modalContainerHeader ? "modalContainerHeader" : ""
              }
              ref={this.modalheaderRef}
            >
              {this.state.title && (
                <h2
                  id='modal-title'
                  className={
                    "modal-title" +
                    (this.state.description ? " with-description" : "")
                  }
                  tabIndex={-1}
                >
                  {this.state.title}
                </h2>
              )}
              <ModalHeaderButtons
                hideCloseButton={this.state.hideCloseButton}
                showSaveButton={this.state.showSaveButton}
                showCancelButton={this.state.showCancelButton}
                saveCallback={this.saveCallback}
                cancelCallback={this.cancelCallback}
                removeModal={this._removeModal}
              />
              {this.state.description &&
                !this.props.definingClass === "sharing" && (
                  <p className="modal-description">{this.state.description}</p>
                )}
            </div>
            {this.state.launchBanner && (
              <div id="launch-banner">
                <button className="noButton">Connect with you student</button>
              </div>
            )}
            <div
              id="modal-content-container"
              style={{ top: this.state.modalHeaderHeight }}
              className={
                "modal-content" +
                (buttons.length > 0 || this.props.delegateButtons
                  ? " with-buttons"
                  : "") +
                (this.state.title ? "" : " no-title") +
                (this.state.description ? " with-description" : "") +
                (this.props.className ? " " + this.props.className : " ") +
                this.props.definingClass
              }
            >
              {this.state.content}
            </div>
            <ModalButtons
              buttons={buttons}
              modalCloseCallback={this.props.modalCloseCallback}
            />
          </div>
        </div>
        <div
          onClick={this._removeModal}
          aria-hidden={true}
          className="modalOverlay"
          tabIndex="-1"
        />
        <div
          aria-hidden={true}
          onFocus={this._bottomTrapKey}
          className="traptabkey"
          tabIndex={0}
        />
      </div>
    );
  }
}

export default VstModalContainer;
